// 既存（生徒導線 + 読み取り）
import getCoursesApi from './getCoursesApi'
import getCourseApi from './getCourseApi'
import getLessonApi from './getLessonApi'
import getCourseQuizzesApi from './getCourseQuizzesApi'
import getQuizApi from './getQuizApi'
import postQuizAttemptApi from './postQuizAttemptApi'
import getGradesApi from './getGradesApi'
import getFeedbackApi from './getFeedbackApi'
import postFeedbackApi from './postFeedbackApi'
import patchFeedbackApi from './patchFeedbackApi'
import postFeedbackReadApi from './postFeedbackReadApi'
import getFeedbackUnreadApi from './getFeedbackUnreadApi'

// 講師/管理者（コンテンツ編集・管理）
import putCourseApi from './putCourseApi'
import postModuleApi from './postModuleApi'
import putModuleApi from './putModuleApi'
import deleteModuleApi from './deleteModuleApi'
import reorderModulesApi from './reorderModulesApi'
import reorderModuleMaterialsApi from './reorderModuleMaterialsApi'
import postModuleItemApi from './postModuleItemApi'
import postModuleExternalLinkApi from './postModuleExternalLinkApi'
import deleteModuleItemApi from './deleteModuleItemApi'
import postLessonApi from './postLessonApi'
import putLessonApi from './putLessonApi'
import deleteLessonApi from './deleteLessonApi'
import postModuleMaterialApi from './postModuleMaterialApi'
import postLessonMaterialApi from './postLessonMaterialApi'
import deleteModuleMaterialApi from './deleteModuleMaterialApi'
import deleteLessonMaterialApi from './deleteLessonMaterialApi'
import postQuizApi from './postQuizApi'
import putQuizApi from './putQuizApi'
import deleteQuizApi from './deleteQuizApi'
import postAnnouncementApi from './postAnnouncementApi'
import putAnnouncementApi from './putAnnouncementApi'
import deleteAnnouncementApi from './deleteAnnouncementApi'
import getStudentsApi from './getStudentsApi'
import getStudentGradesApi from './getStudentGradesApi'
import putModuleProgressApi from './putModuleProgressApi'
import postFeedbackReplyApi from './postFeedbackReplyApi'
import patchFeedbackReplyApi from './patchFeedbackReplyApi'

// 管理者（admin）
import postCourseApi from './postCourseApi'
import deleteCourseApi from './deleteCourseApi'
import getEnrollmentsApi from './getEnrollmentsApi'
import postEnrollmentApi from './postEnrollmentApi'
import deleteEnrollmentApi from './deleteEnrollmentApi'
import getTeachersApi from './getTeachersApi'
import getAttemptReviewApi from './getAttemptReviewApi'
import patchTeacherActiveApi from './patchTeacherActiveApi'
import patchUserLmsApi from './patchUserLmsApi'
import getAllQuizzesApi from './getAllQuizzesApi'
import getAllMaterialsApi from './getAllMaterialsApi'
import putModuleMaterialApi from './putModuleMaterialApi'
import putLessonMaterialApi from './putLessonMaterialApi'

export default {
  getCoursesApi,
  getCourseApi,
  getLessonApi,
  getCourseQuizzesApi,
  getQuizApi,
  postQuizAttemptApi,
  getGradesApi,
  getFeedbackApi,
  postFeedbackApi,
  patchFeedbackApi,
  postFeedbackReadApi,
  getFeedbackUnreadApi,
  putCourseApi,
  postModuleApi,
  putModuleApi,
  deleteModuleApi,
  reorderModulesApi,
  reorderModuleMaterialsApi,
  postModuleItemApi,
  postModuleExternalLinkApi,
  deleteModuleItemApi,
  postLessonApi,
  putLessonApi,
  deleteLessonApi,
  postModuleMaterialApi,
  postLessonMaterialApi,
  deleteModuleMaterialApi,
  deleteLessonMaterialApi,
  postQuizApi,
  putQuizApi,
  deleteQuizApi,
  postAnnouncementApi,
  putAnnouncementApi,
  deleteAnnouncementApi,
  getStudentsApi,
  getStudentGradesApi,
  putModuleProgressApi,
  postFeedbackReplyApi,
  patchFeedbackReplyApi,
  postCourseApi,
  deleteCourseApi,
  getEnrollmentsApi,
  postEnrollmentApi,
  deleteEnrollmentApi,
  getTeachersApi,
  getAttemptReviewApi,
  patchTeacherActiveApi,
  patchUserLmsApi,
  getAllQuizzesApi,
  getAllMaterialsApi,
  putModuleMaterialApi,
  putLessonMaterialApi,
}
